"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../../utils/documents");

var _strings = require("../../../utils/strings");

var _DocumentVersionActions = _interopRequireDefault(require("./DocumentVersionActions"));

var _DocumentVersionText = _interopRequireDefault(require("./DocumentVersionText"));

var _DocumentVersionPayrollRatio = _interopRequireDefault(require("./DocumentVersionPayrollRatio"));

var _jsxRuntime = require("react/jsx-runtime");

function DocumentVersion(props) {
  var _this = this;

  function renderCertifyingThirdParty() {
    var certifyingThirdParty = props.document.certifyingThirdParty;

    if ((0, _strings.isEmpty)(certifyingThirdParty)) {
      return null;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
      className: "separator information",
      "data-id": "document-version-certifying-third-party",
      children: certifyingThirdParty
    });
  }

  function getVersionClass() {
    var state = props.document.state;

    if (_documents.DOCUMENT_STATES_VALID.includes(state)) {
      if (props.isCurrent === true) {
        return 'current';
      }

      if (props.isCurrent === false) {
        return '';
      }

      return 'valid';
    }

    if ([_documents.DOCUMENT_STATE.EXPIRED, _documents.DOCUMENT_STATE.MISSING, _documents.DOCUMENT_STATE.REJECTED].includes(state)) {
      return 'rejected';
    }

    if ([_documents.DOCUMENT_STATE.AWAITING_SIGNATURE, _documents.DOCUMENT_STATE.AWAITING_VALIDATION, _documents.DOCUMENT_STATE.AWAITING_GATHERING].includes(state)) {
      return 'awaiting-verification';
    }

    return '';
  }

  function renderWorkerName() {
    var _props$document;

    if ((0, _strings.isEmpty)(props === null || props === void 0 ? void 0 : (_props$document = props.document) === null || _props$document === void 0 ? void 0 : _props$document.workerFirstName)) {
      return null;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-id": "document-version-worker-name",
      className: "separator information",
      children: "".concat(props.document.workerLastName, " ").concat(props.document.workerFirstName)
    });
  }

  function renderAdditionalDesignation() {
    if ((0, _strings.isEmpty)(props.document.additionalDesignation)) {
      return null;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-id": "document-version-additional-designation",
      className: "separator information",
      children: props.document.additionalDesignation
    });
  }

  function handleOpen() {
    if (props.documentPermissions.isBackOffice) {
      props.documentActions.onOpen(props.document);
    }
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-id": "version-box",
    className: "version-box ".concat(getVersionClass.call(this)),
    children: [props.isCurrent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "current-label",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "document.documentVersion.ongoingLabel"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "font-size-s ".concat(props.documentPermissions.isBackOffice ? 'clickable bo' : ''),
        onClick: function onClick() {
          return handleOpen.call(_this);
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          "data-id": "document-version-title",
          children: props.document.type.name
        }), renderCertifyingThirdParty.call(this), renderWorkerName.call(this), renderAdditionalDesignation.call(this)]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersionActions.default, {
        document: props.document,
        documentPermissions: props.documentPermissions,
        documentActions: props.documentActions
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersionText.default, {
      document: props.document
    }), props.documentPermissions.canSeePayrollRatio && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersionPayrollRatio.default, {
      document: props.document
    })]
  });
}

DocumentVersion.propTypes = {
  document: (0, _documents.documentVersionPropTypes)().isRequired,
  documentPermissions: (0, _documents.documentPermissionsPropTypes)().isRequired,
  documentActions: (0, _documents.documentActionsPropTypes)().isRequired,
  isCurrent: _propTypes.default.bool
};
var _default = DocumentVersion;
exports.default = _default;
//# sourceMappingURL=DocumentVersion.js.map